export default "__VITE_ASSET__a3b100ce__"